import React from 'react';
import { Card } from '../components/ui/display/Card.jsx';
import { Input } from '../components/ui/forms/Input.jsx';
import { Button } from '../components/ui/actions/Button.jsx';
import { tFor } from '../i18n/i18n.js';

// Customer details form. Owns its own input state; on submit, calls
// onSubmit with the validated payload. Validations are minimal — the
// server is the source of truth and re-validates with Joi.

export function StepDetails({
  initial,
  onSubmit,
  onBack,
  submitting,
  locale,
  errorMessage,
}) {
  const t = tFor(locale);
  const [form, setForm] = React.useState({
    customerName: initial?.customerName ?? '',
    customerEmail: initial?.customerEmail ?? '',
    customerPhone: initial?.customerPhone ?? '',
    notes: initial?.notes ?? '',
  });
  const [errors, setErrors] = React.useState({});

  const onField = (key) => (e) => {
    setForm((f) => ({ ...f, [key]: e.target.value }));
    setErrors((er) => ({ ...er, [key]: null }));
  };

  const submit = (e) => {
    e.preventDefault();
    const next = {};
    if (!form.customerName.trim()) next.customerName = t('common.required');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.customerEmail.trim()))
      next.customerEmail = t('common.required');
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    onSubmit({
      customerName: form.customerName.trim(),
      customerEmail: form.customerEmail.trim(),
      customerPhone: form.customerPhone.trim() || null,
      notes: form.notes.trim() || null,
    });
  };

  return (
    <Card title={t('details.heading')}>
      <form
        onSubmit={submit}
        style={{ display: 'flex', flexDirection: 'column', gap: 14 }}
      >
        <Input
          label={t('details.name')}
          value={form.customerName}
          onChange={onField('customerName')}
          error={errors.customerName}
          autoComplete="name"
          required
        />
        <Input
          label={t('details.email')}
          type="email"
          value={form.customerEmail}
          onChange={onField('customerEmail')}
          error={errors.customerEmail}
          autoComplete="email"
          required
        />
        <Input
          label={t('details.phone')}
          type="tel"
          value={form.customerPhone}
          onChange={onField('customerPhone')}
          autoComplete="tel"
        />
        <Input
          label={t('details.notes')}
          value={form.notes}
          onChange={onField('notes')}
          hint={null}
        />
        {errorMessage && (
          <div className="sp-message is-error">{errorMessage}</div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between' }}>
          <Button type="button" variant="secondary" onClick={onBack}>
            {t('common.back')}
          </Button>
          <Button type="submit" disabled={submitting}>
            {submitting ? t('common.loading') : t('details.continue')}
          </Button>
        </div>
      </form>
    </Card>
  );
}